<!--Wedding Planning section-->
<section class="wedding-plan-cta">
    <div class="container">
        <img [src]="imagePathConstants.GENERAL+'/book-icon.svg'" width="43" height="40" alt="Book icon" loading="lazy">
        <p>Click here to receive your free e-book: <strong>7 simple steps to kickstart your wedding planning</strong></p>
        <img [src]="imagePathConstants.GENERAL+'/book-icon.svg'" width="43" height="40" alt="Book icon" loading="lazy">
    </div>
</section>
